/**
 * 버튼형 토글(학교·학년 선택 공용). 네이티브 button이라 Tab/Enter/Space가 그대로 동작하고,
 * 선택 상태는 aria-pressed와 화면 표시(on 클래스, ✓)로 함께 알린다.
 */
import { h } from './dom.js';

export function toggleButton(label: string, pressed: boolean, testid: string, onclick: () => void): HTMLButtonElement {
  const b = h('button', {
    type: 'button', class: pressed ? 'toggle on' : 'toggle', 'aria-pressed': pressed ? 'true' : 'false', 'data-testid': testid, onclick,
  }, pressed ? `✓ ${label}` : label);
  return b;
}
